import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 py-20 px-4">
            <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12">
                {/* Header */}
                <div className="text-center mb-12">
                    <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#0a1f44] to-[#1e3a5f] rounded-full mb-6">
                        <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                    </div>
                    <h1 className="text-4xl md:text-5xl font-bold text-[#0a1f44] mb-4">
                        Politique de Confidentialité
                    </h1>
                    <p className="text-gray-600">Dernière mise à jour : 7 septembre 2025</p>
                </div>

                {/* Content */}
                <div className="prose prose-lg max-w-none">
                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            1. Introduction
                        </h2>
                        <p className="text-gray-700 leading-relaxed">
                            Chez <strong>WebAura</strong>, nous accordons une grande importance à la protection de vos données personnelles. 
                            Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations 
                            lorsque vous utilisez notre site web et nos services.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            2. Données Collectées
                        </h2>
                        <p className="text-gray-700 leading-relaxed mb-4">
                            Nous collectons les informations suivantes :
                        </p>
                        <ul className="list-disc pl-6 space-y-2 text-gray-700">
                            <li><strong>Informations d'identification :</strong> nom, prénom, adresse email</li>
                            <li><strong>Informations de contact :</strong> numéro de téléphone, adresse</li>
                            <li><strong>Informations professionnelles :</strong> nom de l'entreprise, secteur d'activité</li>
                            <li><strong>Données de navigation :</strong> adresse IP, cookies, pages visitées</li>
                            <li><strong>Informations de projet :</strong> détails de votre demande, préférences</li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            3. Utilisation des Données
                        </h2>
                        <p className="text-gray-700 leading-relaxed mb-4">
                            Nous utilisons vos données pour :
                        </p>
                        <ul className="list-disc pl-6 space-y-2 text-gray-700">
                            <li>Traiter et répondre à vos demandes de services</li>
                            <li>Vous contacter concernant votre projet</li>
                            <li>Améliorer nos services et votre expérience utilisateur</li>
                            <li>Vous envoyer des informations sur nos offres (avec votre consentement)</li>
                            <li>Respecter nos obligations légales</li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            4. Protection des Données
                        </h2>
                        <p className="text-gray-700 leading-relaxed">
                            Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour protéger vos données 
                            contre tout accès, modification, divulgation ou destruction non autorisés. Vos données sont stockées sur 
                            des serveurs sécurisés et l'accès est strictement limité aux personnes autorisées.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            5. Partage des Données
                        </h2>
                        <p className="text-gray-700 leading-relaxed mb-4">
                            Nous ne vendons ni ne louons vos données personnelles. Nous pouvons partager vos informations avec :
                        </p>
                        <ul className="list-disc pl-6 space-y-2 text-gray-700">
                            <li>Nos prestataires de services (hébergement, paiement) sous contrat de confidentialité</li>
                            <li>Les autorités légales si la loi l'exige</li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            6. Vos Droits
                        </h2>
                        <p className="text-gray-700 leading-relaxed mb-4">
                            Conformément au RGPD, vous disposez des droits suivants :
                        </p>
                        <ul className="list-disc pl-6 space-y-2 text-gray-700">
                            <li><strong>Droit d'accès :</strong> obtenir une copie de vos données</li>
                            <li><strong>Droit de rectification :</strong> corriger vos données inexactes</li>
                            <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
                            <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
                            <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
                        </ul>
                        <p className="text-gray-700 leading-relaxed mt-4">
                            Pour exercer ces droits, contactez-nous à : <a href="mailto:marml@ept.sn" className="text-amber-600 hover:text-amber-700 font-semibold">marml@ept.sn</a>
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            7. Cookies
                        </h2>
                        <p className="text-gray-700 leading-relaxed">
                            Notre site utilise des cookies pour améliorer votre expérience. Vous pouvez gérer vos préférences de cookies 
                            dans les paramètres de votre navigateur. Certains cookies sont essentiels au fonctionnement du site.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            8. Modifications
                        </h2>
                        <p className="text-gray-700 leading-relaxed">
                            Nous pouvons mettre à jour cette politique de confidentialité. Les modifications seront publiées sur cette page 
                            avec la date de mise à jour. Nous vous encourageons à consulter régulièrement cette page.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold text-[#0a1f44] mb-4 flex items-center">
                            <span className="w-2 h-8 bg-amber-500 rounded mr-3"></span>
                            9. Contact
                        </h2>
                        <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-6 rounded-xl border-2 border-amber-200">
                            <p className="text-gray-700 leading-relaxed mb-4">
                                Pour toute question concernant cette politique de confidentialité ou vos données personnelles :
                            </p>
                            <div className="space-y-2 text-gray-700">
                                <p><strong>Email :</strong> <a href="mailto:contact@webaura.dev" className="text-amber-600 hover:text-amber-700">contact@webaura.dev</a></p>
                                <p><strong>Téléphone :</strong> <a href="tel:+221779317865" className="text-amber-600 hover:text-amber-700">+221 77 931 78 65</a></p>
                                <p><strong>Adresse :</strong> Dakar, Sénégal</p>
                            </div>
                        </div>
                    </section>
                </div>

                {/* Back Button */}
                <div className="mt-12 text-center">
                    <Link 
                        to="/" 
                        className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0a1f44] to-[#1e3a5f] text-white px-8 py-4 rounded-full font-semibold hover:from-[#1e3a5f] hover:to-[#2c5282] transform hover:scale-105 transition-all duration-300 shadow-lg"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                        Retour à l'accueil
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
